<template>
  <div
    class="payment-box"
    :style="smallScreen ? 'padding: 1.5rem 3rem;' : 'padding: 1rem 2rem;'"
    :data-tst="`payment_plan_${id}`"
    :class="[
      { 'payment-box_compact': compact },
      { selected: selected },
      { 'selected-grey': selectedGrey },
    ]"
    @click="$emit('click')"
  >
    <div
      v-if="$slots.default"
      class="payment-box_radio"
    >
      <slot />
    </div>

    <div
      v-if="discountEligible && nextYearPrice"
      class="payment-box_title"
    >
      {{ $t('tier.options.annualy') }}
      <div class="text-small">
        {{
          $t('subscription.first_year_price_tra01', {
            price: numFixed(option.year_price),
          })
        }}
        <div class="clr-grey">
          {{
            $t('subscription.then_next_year_price_tra01', {
              price: numFixed(nextYearPrice),
            })
          }}
        </div>
      </div>
    </div>

    <div
      v-else
      class="payment-box_title"
    >
      {{ title }}
      <div
        v-if="subtitle"
        class="payment-box_title_sub mt-auto"
      >
        {{ subtitle }}
      </div>
    </div>
    <div class="payment-box_price">
      <div class="text-nowrap d-flex position-relative">
        <div
          v-if="priceNoDiscount"
          class="full-price anim-fade-in"
        >
          <span class="text-crossed-out"> {{ numFixed(priceNoDiscount) }} </span>
        </div>
        <div>
          {{ numFixed(price) }}
          <span class="starting-at-month">
            USD /
            {{
              discountEligible && !nextYearPrice
                ? $t('subscription.first_month')
                : $t('subscription.month')
            }}
          </span>
        </div>
      </div>
      <div
        v-if="discountEligible && nextMonthPrice"
        class="text-small clr-grey"
      >
        {{
          $t('subscription.then_next_month_price_tra01', {
            price: numFixed(nextMonthPrice),
          })
        }}
      </div>
      <div
        v-if="tagText"
        class="payment-box_tag mt-auto"
        :class="{ 'payment-box_tag_grey': tagGrey }"
      >
        {{ tagText }}
      </div>
    </div>

    <div
      v-if="!compact"
      style="font-size: 3rem; padding: 0.5rem; margin-right: -0.5rem"
      class="ml-auto mdi mdi-chevron-right icon_btn clr-primary"
    ></div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'

export default {
  name: 'PaymentSelectionBox',
  mixins: [format_mix],
  props: {
    discountEligible: Boolean,
    nextMonthPrice: Number,
    nextYearPrice: Number,
    id: String,
    title: String,
    subtitle: String,
    price: Number,
    priceNoDiscount: Number,
    savings: String,
    selected: Boolean,
    compact: Boolean,
    tagText: String,
    option: Object,
    // tagPrimary: Boolean,
    // tagRight: Boolean,
    tagGrey: Boolean,
    selectedGrey: Boolean,
  },
  emits: ['click'],
  data() {
    return {
      error: false,
    }
  },
  computed: {
    mdAndDown() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
    smallScreen() {
      const { globals_window_size } = this.$store.getters
      return globals_window_size.width < 768
    },
  },
}
</script>

<style lang="scss" scoped>
// .full-price-on-top {
//   .full-price {
//     // position: absolute;
//     // top: -1.5rem;
//   }
//   .full-price-container {
//     // position: relative;
//     // top: 1rem;
//   }
// }
.full-price {
  position: absolute;
  left: -3.5rem;
  color: var(--clr-grey-2);
  // margin-left: -100%;
  width: 3rem;
  text-align: right;
}
.payment-box {
  --title-size: 1.25rem;
  font-weight: 500;
  position: relative;
  display: flex;
  width: 34rem;
  max-width: calc(100vw - 2rem);
  &_full-width {
    max-width: unset !important;
  }
  height: 8.4rem;
  align-items: center;
  background: var(--clr-black-1-3);
  border-radius: 4px;
  // margin: 1rem 0;
  transition: 0.2s;
  &:hover {
    background: var(--clr-black-2);
    cursor: pointer;
  }
  &_compact {
    width: 100%;
    height: 6.5rem;
    padding: 1rem 1.5rem;
  }
  &_radio {
    // position: absolute;
    margin-right: 2rem;
  }
  &_title {
    // font-size: 1.25rem;
    font-size: var(--title-size);
    width: 13rem;
    height: 3rem;
    display: flex;
    flex-direction: column;
    padding-right: 0.5rem;
    justify-content: center;
    &_sub {
      padding-right: 0.5rem;
      font-size: 0.875rem;
      font-weight: 500;
    }
  }
  &_price {
    height: 3rem;
    display: flex;
    gap: 0.125rem;
    font-size: 1.25rem;
    flex-direction: column;
    justify-content: center;
    margin-block: auto;
    .starting-at-month {
    }
    .savings {
    }
  }
  &_tag {
    background: var(--clr-primary, 1.25rem);
    border-radius: 4px;
    text-align: center;
    font-size: 0.875rem;
    font-weight: 500;
    // width: 4rem;
    padding: 0 4px;
    // margin-left: auto;
    // background: var(--clr-primary);
    // position: absolute;
    // left: -4rem;
    // white-space: nowrap;
    // width: 6.75rem;
    // transform: rotate(-90deg);
    // text-align: center;
    // border-radius: 4px;
    // font-weight: 500;
    // text-transform: uppercase;
    // &_top {
    //   right: -1px !important;
    //   left: unset !important;
    //   transform: rotate(0deg) !important;
    //   top: -1px !important;
    //   padding: 0 8px;
    //   font-size: 0.8rem;
    //   // width: unset !important;
    // }
    // &_right {
    //   right: -1px !important;
    //   left: unset !important;
    //   transform: rotate(0deg) !important;
    //   top: -1px !important;
    //   padding: 0 8px;
    //   font-size: 0.8rem;
    //   // width: unset !important;
    // }
    // &_primary {
    //   background: var(--clr-primary);
    // }
    &_grey {
      background: var(--clr-black-3);
    }
  }
}
.selected {
  box-shadow: 0px 0px 0px 2px var(--clr-primary);
  background: var(--clr-black-2);
  // transform: scale(1.025);
}
.selected-grey {
  box-shadow: 0px 0px 0px 2px var(--clr-black-3);
}
// .best-value {
//   border: solid 2px var(--clr-primary);
// }
// .best-value-box-top {
// }
// .best-value-box {
// }
</style>
